import { render, staticRenderFns } from "./VisaoGeralFazenda.vue?vue&type=template&id=a0c75a68&scoped=true&lang=pug"
import script from "./VisaoGeralFazenda.vue?vue&type=script&lang=js"
export * from "./VisaoGeralFazenda.vue?vue&type=script&lang=js"
import style0 from "./VisaoGeralFazenda.vue?vue&type=style&index=0&id=a0c75a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c75a68",
  null
  
)

export default component.exports